import { ExportViewAttendanceExcel } from "./ExportViewAttendanceExcel";
import { ExportViewAttendancePdf } from "./ExportViewAttendancePdf";

export const ExportViewAttendance = ({ attendanceData = [], fetchExportData }) => (
    <div className="d-flex flex-wrap gap-2">
        <ExportViewAttendanceExcel attendanceData={attendanceData} fetchExportData={fetchExportData} />
        <ExportViewAttendancePdf attendanceData={attendanceData} fetchExportData={fetchExportData} />
    </div>
);
